import axios from 'axios';
import MockAdapter from 'axios-mock-adapter';
import NProgress from '../utils/nprogress';
import { LoginResult } from '../models/api';

interface Headers {
  [key: string]: any,
}

let token: string | null = null;
const fileDelete: string[] = [];
const fileLog = [
  {
    fileName: 'lk2.log',
    size: 15803,
    modifyAt: '2023-03-29T11:44:19.562113892+07:00',
    text: '[lk2] file log',
    canDelete: true,
  },
  {
    fileName: 'server-2016-11-04T18-30-00.000.log',
    size: 5,
    modifyAt: '2023-03-22T16:07:59.310882059+07:00',
    text: '[server-2016-11-04T18-30-00.000] file log',
    canDelete: true,
  },
  {
    fileName: 'test.log',
    size: 0,
    modifyAt: '2023-03-22T13:23:34.822782013+07:00',
    text: '[test] file log',
    canDelete: true,
  },
  {
    fileName: 'test2.log',
    size: 0,
    modifyAt: '2023-03-29T11:45:04.14422771+07:00',
    text: '[test2] file log',
    canDelete: true,
  },
];

const api = axios.create({
  baseURL: '/api/manage',
});

api.interceptors.request.use((requestData) => {
  NProgress.start();
  if (token != null) requestData.headers.setAuthorization(`Basic ${token}`);
  return requestData;
});

api.interceptors.response.use((responseData) => {
  NProgress.done();
  const { method, url } = responseData.config;

  if (method !== 'post') return responseData;
  if (url !== '/login/') return responseData;

  token = responseData.data.token;

  return Promise.resolve(responseData.data);
}, (responseError) => {
  NProgress.done();
  return Promise.reject(responseError);
});

export default {
  init: (loginToken: string) => { token = loginToken; },
  login: (username: string, password: string) => api.post('/login/', { username, password }),
  register: () => api.post('/register'),
  connection: () => api.get('/status/connection/'),
  log: (fileName?: string, headers?: Headers) => api.get(`/log/${fileName ?? ''}`, headers ? { headers } : undefined),
  deleteLog: (fileName: string) => api.delete(`/log/${fileName}`),
  logout: () => { token = null; },
  mock: () => {
    new MockAdapter(api, { delayResponse: 100 })
      .onPost('/login/').reply((config) => {
        const dataBody = JSON.parse(config.data);
        if (dataBody.username === 'admin' && dataBody.password === '1234') {
          return [
            200,
            {
              token: 'YWRtaW46OWIzNDMwYTNiMTI1OTU0ZTA1NDBiYjE5YzhiOWM1ZmMzNjUxYTliYTA0NmZlYjQzMTg3MzBiZjcwZWRiM2FlMjZlOTFiODM2NzBlZGE2MDQ=',
              officeID: 22,
              officeName: 'สำนักทดสอบ กรมการทดสอบ',
              superuser: 'นายทดสอบ ลงทะเบียน',
              registerStatus: false,
              registerAt: '2023-01-01T01:02:03.000+07:00',
              proxyID: 1,
            },
          ];
        }
        return [
          401,
          {
            massage: 'username or password invalid',
          },
        ];
      })
      .onPost('/register').reply(200, {
        registerAt: '2023-05-01T01:02:03.000+07:00',
      })
      .onGet('/status/connection/').reply(200, {
        status: true,
        healthCheckedAt: '2023-03-13T10:11:12.000+07:00',
      })
      .onGet('/log/').reply(() => {
        const filter = fileLog.filter((it) => !fileDelete.includes(it.fileName));
        return [200, filter.map((it) => ({
          fileName: it.fileName,
          size: it.size,
          modifyAt: it.modifyAt,
        }))];
      })
      .onGet(/\/log\/\w+/).reply((config) => {
        if (config.headers?.Accept === 'text/plain') {
          const files: string[] = (config.url ?? '').split('/');
          const fileName: string = files[files.length - 1] ?? '';
          const findData = fileLog.find((it) => it.fileName.replace(/(.log)$/i, '') === fileName);
          return findData
            ? [200, findData.text]
            : [404, { massage: 'Not Found' }];
        }
        return [200];
      })
      .onDelete(/\/log\/\w+/).reply((config) => {
        const files: string[] = (config.url ?? '').split('/');
        console.log('🚀 ~ file: api.ts:115 ~ .onDelete ~ files:', files);
        const fileName: string = files[files.length - 1] ?? '';
        const findData = fileLog.find((it) => it.fileName.replace(/(.log)$/i, '') === fileName);
        if (findData) fileDelete.push(findData.fileName);
        return findData ? [204] : [404];
      });
  },
};
